export const baseToTop = (a, b) => {
  return a.isBase - b.isBase;
};
